import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'azureBranchName'})
export class AzureBranchNamePipe implements PipeTransform {
    transform(refName: string): string {
        if (!refName) {
            return '';
        }
        return refName.replace(/^refs\/heads\//, '');
    }
}
